import { render } from "./InputImage.vue?vue&type=template&id=edd3e3a6&ts=true"
import script from "./InputImage.vue?vue&type=script&lang=ts"
export * from "./InputImage.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__